// TinyMCE table wrapper config

const richtextTableEls = document.querySelectorAll('.richtext table');
richtextTableEls.forEach((table) => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('table-responsive');
    table.parentNode.replaceChild(wrapper, table);
    wrapper.appendChild(table);
});
